import { render, staticRenderFns } from "./bar-chart.vue?vue&type=template&id=268b01c3&scoped=true&"
import script from "./bar-chart.vue?vue&type=script&lang=js&"
export * from "./bar-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268b01c3",
  null
  
)

export default component.exports